module.exports = __webpack_public_path__ + "img/customer_3.ac495112.png";